(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["noel-video"] && !Shopify.designMode) return;
  try {
    
function mountNoelVideo(root) {
  root.querySelectorAll('.noel-motion__video').forEach((video) => {
    if (video.dataset.motionReady) return;
    video.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { video.muted = true; video.play().catch(() => {}); }
        else video.pause();
      });
    }, { threshold: 0.35 });
    observer.observe(video);
  });
}
mountNoelVideo(document);
document.addEventListener('shopify:section:load', (event) => mountNoelVideo(event.target));

  } catch(e) { console.error(e); }
})();
})();
